<template>
  <div>
    <div v-if="tableLoader">
      <Loader />
    </div>
    <div class="card tw-mt-4">
      <div
        class="d-flex gap-3 tw-justify-between tw-items-center"
        id="sentiments-filters"
      >
        <div class="d-flex gap-3 flex-wrap tw-items-center">
          <div class="mr-2">
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Date"][selectedLanguage.key] }}
            </div>
            <date-range-picker
              v-model="dateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDateTableDateRange"
              :max-date="maxDateTableDateRange"
            >
              <!-- @update="getBuyBoxTable" -->
            </date-range-picker>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1 ml-0"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Platform"][selectedLanguage.key] }}
            </div>

            <multiselect
              @input="handlePlatformSelection"
              v-model="selectedPlatform"
              class="text-capitalize"
              :options="platformList"
              track-by="key"
              label="value"
              :custom-label="updateSelectedLabels"
              :multiple="true"
              :searchable="false"
              placeholder="Select Platform"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedPlatform?.length == platformList?.length ? 1 : 100
              "
            >
              <template #option="{ option }">
                <div class="tw-flex tw-gap-2">
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedPlatform"
                  />
                  <div class="custom-option text-capitalize">
                    {{ option.value.replaceAll("_", " ") }}
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedTableCategory"
              class="text-capitalize"
              :options="categoryList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedTableCategory?.length == categoryList?.length ? 1 : 100
              "
              @input="handleChangeCategory"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTableCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Sub Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedTableSubCategory"
              class="text-capitalize"
              :options="subCategoryList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Sub Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedTableSubCategory?.length == subCategoryList?.length
                  ? 1
                  : 100
              "
              @input="handleChangeSubCategory"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTableSubCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Brand"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedBrand"
              class="text-capitalize"
              :options="lossBrandList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Brand"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                lossSelectedBrand?.length == lossBrandList?.length ? 1 : 100
              "
              @input="handleBrand"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedBrand"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <!-- <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template> -->
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 220px; max-width: 220px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              Level 1
            </div>
            <multiselect
              v-model="selectedL1Data"
              class="text-capitalize"
              :options="viewL1Data"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Level 1"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                viewL1Data?.length == viewL1Data?.length
                  ? 1
                  : 100
              "
              @input="handleChangeL1"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedL1Data"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 180px; max-width: 180px"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Level 2"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedL2Data"
              limit="1"
              :options="viewL2Data"
              :multiple="true"
              :searchable="false"
              placeholder="Select Level 2"
              :close-on-select="false"
              :allow-empty="true"
              :showLabels="false"
              track-by="key"
              label="value"
              :limit="selectedL2Data?.length == viewL2Data?.length ? 1 : 1000"
              @input="handleChangeL2"
            >
              <template #option="{ option }">
                <div>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedL2Data"
                  />
                  <span class="option__title ml-3">{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
         
          <button
            class="btn primarycolor py-2 tw-mt-4"
            @click="handleApplyFilters"
          >
            {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
          </button>
        </div>
      </div>
    </div>

    <div class="card"> 
      <div class="summaryContainer">
          <div class="" v-if="viewReviewSentimentData?.data.table.length">
            <table id="summaryTable" class="tw-w-full">
              <thead class="thead-normal">
                <tr>
                  <th
                    :colspan="header.subData"
                    v-for="header in viewReviewSentimentData.headers"
                    :key="header.key"
                  >
                    {{ header.label }}
                  </th>
                </tr>
                <tr>
                  <template
                    v-for="header in viewReviewSentimentData.headers"
                    class="tw-bg-black"
                  >
                    <th
                      v-for="sub in header.subHeaders"
                      :key="sub.key" class="tw-p-0 !tw-bg-background_color"
                    >
                      <div
                        class="tw-flex tw-items-center tw-gap-2 tw-justify-center"
                      >
                        {{ sub.label
                        }}
                      </div>
                    </th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, rowIndex) in viewReviewSentimentData.data.table"
                  :key="'|' + rowIndex"
                  class="tw-border tw-border-[#d4d4d4] tw-capitalize"
                >
                  <template
                    v-for="header in viewReviewSentimentData.headers"
                  >
                    <td
                      v-for="sub in header.subHeaders"
                      :key="sub.key" class="tw-p-0"
                    >
                      <div
                        class="tw-w-[150px]"
                        v-if="sub.key=='count'"

                      >
                    
                      <div class="tw-w-[100%]">
                      
                        <bar
                          :data="row[header.key][sub.key].negative_percent"
                          customColor="tw-bg-[#B91C1C]"
                          :labelDataLeft="formatNumber(row[header.key][sub.key].negative_percent) + '%'"
                        />
                      </div>
                      <div class="tw-w-[100%]">
                        <bar
                          :data="row[header.key][sub.key].positive_percent"
                          :labelDataLeft="formatNumber(row[header.key][sub.key].positive_percent)+'%'"
                        />
                      </div>
                      </div>
                      <div v-else-if="sub.key == 'count_percent'" class=" tw-flex tw-justify-center">
                      <div class="tw-w-[200px]">
                       <bar
                          :data="row[header.key][sub.key].negative_percent"
                          customColor="tw-bg-[#B91C1C]"
                          :customBg="[row[header.key][sub.key].positive_percent > 0 ? '!tw-bg-[#065558] !tw-w-[150px]' : '']"
                          :labelDataLeft="formatNumber(row[header.key][sub.key].positive_percent) + '%'"
                          :labelDataRight="formatNumber(row[header.key][sub.key].negative_percent)+ '%'"
                        />
                      </div>
                      </div>
                      <div  class="tw-flex tw-items-center tw-gap-2 tw-justify-center tw-text-[#5A5A5A]" v-else-if="sub.key=='level1'"> 
                        {{ formatNumber(row[header.key][sub.key])}}
                      </div>
                      <div  @click="openModal(row[header.key][sub.key])" class="tw-flex tw-items-center tw-gap-2 tw-justify-center tw-cursor-pointer tw-text-blue"  v-else-if="sub.key=='level3'"> 
                        {{ formatNumber(row[header.key][sub.key])}}
                      </div>
                      <div class="tw-flex tw-items-center tw-gap-2 tw-justify-center" v-else> 
                        {{ formatNumber(row[header.key][sub.key])}}
                      </div>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="tw-min-h-[400px]">
            <noData :loaderVariable="sentimentLoader" />
          </div>
        </div>
    </div>

    <b-modal
      v-model="keywordModal"
      size="xl"
      :title="modalTitle"
      @hidden="resetModal"
    >
      <!-- <div class="tw-flex tw-justify-end">
                <div>
                    <div>Positive Review <span></span></div>
                    <div>Negative Reviews <span></span></div>
                </div>
            </div> -->
      <div class="modal-control-panel mt-3">
        <ul>
          <li
            v-for="tab of modalTabs"
            :key="tab"
            @click="selectedModalTab = tab"
            :class="{ 'selected-tab': tab === selectedModalTab }"
          >
            {{ translatedLang[tab][selectedLanguage.key] }}
          </li>
        </ul>
        <div class="d-flex" style="margin-top: -16px">
          <b-button-toolbar
            aria-label="Toolbar with buttons group"
            v-show="
              selectedModalTab === 'Frequency' ||
              selectedModalTab === 'Score' ||
              selectedModalTab === 'Review Count'
            "
          >
            <b-form-radio-group
              class="mr-3 radiohide"
              id="radiosBtn"
              buttons
              button-variant="outline-secondary"
              @change="updateSentimentData"
              v-model="keywordInterval"
              name="radiosBtn"
            >
              <b-form-radio class="mx-0" value="month">{{
                translatedLang["Month"][selectedLanguage.key]
              }}</b-form-radio>
              <b-form-radio class="mx-0" value="week">{{
                translatedLang["Week"][selectedLanguage.key]
              }}</b-form-radio>
            </b-form-radio-group>
          </b-button-toolbar>
          <div></div>
          <date-range-picker
            v-model="modalDateRange"
            :show-dropdowns="true"
            opens="right"
            :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }"
            :min-date="minDate"
            :max-date="maxDate"
            :ranges="false"
            @update="updateModal"
          >
          </date-range-picker>
        </div>
      </div>
      <div v-if="Object.keys(keywordWiseSentiments).length">
        <KeywordModalCard
          :selectedTab="selectedModalTab"
          :keywordReview="keywordWiseReviews"
          :keywordSentiment="keywordWiseSentiments"
          :keywordTreeData="keywordTreeData"
          :isKeywordReview="isKeywordReview"
          @filter-reviews="filterReviews"
          @toggle-node="toggleTreeNode"
        />
      </div>
      <!-- <div v-else-if="isKeywordReview">
        <noData :loaderVariable="isKeywordReview" />
      </div> -->
      <div v-else>
        <noData :loaderVariable="isKeywordData" />
      </div>
    </b-modal>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Loader from "../Components/Loader.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapState, mapActions } from "vuex";
import upDownCard from "@/views/v3/Components/upDownCard.vue";
import bar from "@/views/v3/Components/bar.vue";
import negativeColumnChart from "../commonCharts/Chart/negativeColumnChart.vue";
import noData from "../Components/noData.vue";
import KeywordModalCard from "./Components/KeywordModalCard.vue";
export default {
  name: "sos",
  components: {
    Multiselect,
    Datepicker,
    Loader,
    Treeselect,
    upDownCard,
    bar,
    noData,
    negativeColumnChart,
    KeywordModalCard,
  },
  data() {
    return {
      dateRange: {
        startDate: moment().subtract(2, "months").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      modalDateRange: {
        startDate: moment().subtract(3, "months").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, "month")),
      minDateTableDateRange: "",
      maxDateTableDateRange: "",
      selectedPlatform: [],
      platformList: [],
      selectedTableCategory: [],
      categoryList: [],
      categoryTableList: "",
      selectedTableSubCategory: [],
      subCategoryList: [],
      lossSelectedBrand: [],
      lossBrandList: [],
      selectedProduct: [],
      lossProductList: [],
      lossSelectedPIN: [],
      lossPINList: [],
      lossSelectedBatch: [],
      lossBatchList: [],
      tableHeader: [],
      tableData: [],
      tableLoader: false,
      uploadedProducts: {},
      allPincodeList: [],
      finalSelectedCategory: [],
      previousSelection: [],
      previousCategorySelection: [],
      previousSubCategorySelection: [],
      previousBrandSelection: [],
      previousProductSelection: [],
      previousPriceRangeSelection: [],
      lossSelectedPriceRange: [],
      lossPriceRangeList: [],
      viewKeywordList: [],
      selectedKeyword: [],
      previousSelectedKeyword: [],
      storeAllDataForStatus: {},
      client: JSON.parse(localStorage.reviewUserData).data.client,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map.Your_Sentiments,
      viewReviewSentimentData: {headers:[],data:{table:[]}},
      viewReviewSentimentCompareData: [],
      proccedKeywordChartData: {},
      activeTab: "sentimentAnalysis",
      sentimentLoader: false,
      sentimentCamLoader: false,
      hoverKeyword: "",
      viewKeywordList: [],
      selectedKeyword: [],
      previousSelectedKeyword: [],
      // modal variable
      modalLoader: false,
      keywordModal: false,
      selectedModalKeyword: "",
      modalTitle: "",
      keywordWiseReviews: [],
      keywordWiseSentiments: {},
      keywordTreeData: {},
      modalTabs: [
        "Reviews",
        "Frequency",
        // "Score",
        "Review Count",
        // "Tree Structure",
        "Contribution tree",
      ],
      selectedModalTab: "Reviews",
      keywordInterval: "month",
      selectedPositiveCloudLimit: 10,
      selectedNegativeCloudLimit: 10,
      selectedGlobalProduct: null,
      isKeywordData: false,
      storedL1L2Data: {},
      viewL1Data:[],
      viewL2Data:[],
      selectedL1Data: [],
      selectedL2Data: [],
      previousL1Selection: [],
      previousL2Selection: [],
      isKeywordReview:''
    };
  },
  mounted() {
    this.sentimentLoader = true;
    this.sentimentCamLoader = true;
    this.getLastUpdatedDates();
    this.$store.dispatch("DemoStore/setUpdatedStatus", "");
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
  watch: {
    selectedTableCategory(newVal) {
      let mergedChildren = [];
      newVal.forEach((cat) => {
        if (cat.child && Array.isArray(cat.child)) {
          mergedChildren.push(...cat.child);
        }
      });
      this.subCategoryList = mergedChildren;
      if (this.selectedTableCategory?.length && this.subCategoryList.length) {
        this.subCategoryList.unshift({
          key: "All",
          value: "All",
        });
      }
      const validKeys = new Set(mergedChildren.map((c) => c.key));
      this.selectedTableSubCategory = this.selectedTableSubCategory.filter(
        (subcat) => validKeys.has(subcat.key)
      );
      this.selectedTableSubCategory = [...this.subCategoryList];
      this.previousSubCategorySelection = [...this.selectedTableSubCategory];
      // this.selectedTableSubCategory = mergedChildren.length
      //   ? [mergedChildren[0]]
      //   : [];
    },
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    updateSelectedLabels(option) {
      return option.value.replaceAll("_", " ");
    },
    formatData(value) {
      return value.toFixed(2);
    },
    toggleTreeNode(nodeName) {
      this.keywordTreeData.children.forEach((child) => {
        if (child.name == nodeName) {
          child.showChildren = !child.showChildren;
        } else {
          child.showChildren = false;
        }
      });
    },
    formatNumber(num) {
        // Return as-is if value is empty, null, or undefined
        if (num === '' || num === null || num === undefined) {
          return '';
        }

        // If not a valid number, just return original value
        if (isNaN(num)) {
          return num;
        }

        // Only convert if it’s a valid number
        const fixed = Number(num).toFixed(2);
        const formatted = Number(fixed).toLocaleString();
        return formatted;
    },
    getLastUpdatedDates() {
      this.tableLoader = true;
      const url = `/api/v2/india_clients/last_update?client=${this.client}&feature_id=${this.featureId}`;
      this.$http
        .get(url)
        .then((response) => {
          localStorage.sentiments_last_update = JSON.stringify(
            response.body.data?.sentiments
          );
          // this.dateRange.endDate = moment(
          //     response.body.data.sentiments?.end_date
          // ).format("YYYY-MM-DD");
          // this.dateRange.startDate = moment(
          //     response.body.data.sentiments?.end_date
          // ).format("YYYY-MM-DD");
          // this.maxDateTableDateRange = new Date(
          //     response.body.data.sentiments?.end_date
          // );
          this.$store.dispatch("DemoStore/setTimeStamp", "");

          this.getFiltersData();
        })
        .catch((err) => {
          this.tableLoader = false;
          // this.getBrandDetails();
          console.log("err", err);
        })
        .finally(() => {
          this.tableLoader = false;
        });
    },
    // modal variabl
    resetModal() {
      this.selectedModalKeyword = "";
      this.modalTitle = "";
      this.keywordWiseReviews = [];
      this.keywordWiseSentiments = {};
      this.keywordTreeData = {};
      this.selectedModalTab = "Reviews";
      this.keywordInterval = "month";
    },

    updateModal() {
      this.getKeywordReviews();
      this.getKeywordSentiment();
    },

    filterReviews(sentimentType) {
      this.getKeywordReviews(sentimentType);
    },

    updateSentimentData() {      
      this.$nextTick(() => {
        this.getKeywordSentiment();
      });
    },
    openNegativeModal(keyword) {
      this.openModal(keyword, "negative");
    },

    openPositiveModal(keyword) {
      this.openModal(keyword, "positive");
    },

    openModal(targetKeyword, sentType = "") {
      this.selectedModalKeyword = targetKeyword;
      this.modalTitle = `${
        this.translatedLang["Keyword"][this.selectedLanguage.key]
      } : ${targetKeyword}`;
      this.getKeywordReviews(sentType);
      this.getKeywordSentiment();
      this.keywordModal = true;
    },

    getKeywordReviews(sentimentType) {
      const url = "/api/v2/indian_clients/keyword_reviews_data";
      const payload = {
        start_date: moment(this.modalDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.modalDateRange.endDate).format("YYYY-MM-DD"),
        keyword: this.selectedModalKeyword,
        client: this.client,
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        brand_name: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        language: this.selectedLanguage.key,
        category_name: this.finalSelectedCategory,
        product_name: this.selectedProduct?.length
          ? this.selectedProduct
              ?.filter((product) => product.key !== "All")
              .map((product) => product.key)
          : [],
        limit: 50,
        offset: 0,
        sentiment_type: sentimentType || "positive",
        type_of_keyword: "token",
      };

      this.keywordWiseReviews = [];
      this.keywordTreeData = {};
      this.modalLoader = true;

      this.$http
        .post(url, payload)
        .then((res) => {
          this.modalLoader = false;
          this.keywordWiseReviews = res.body.data;
          this.keywordTreeData = res.body.percent;
        })
        .catch((err) => {
          this.modalLoader = false;
          console.log(`Error in fetching keyword reviews`, err);
        });
    },

    getKeywordSentiment() {
      // const productDetails = this.selectedGlobalProduct.split("+");
      // const brandName = productDetails[0];
      // const productName = productDetails[1];
      this.isKeywordData = true;
      const url = "/api/v2/indian_clients/keyword_sentiments_data";
      const payload = {
        start_date: moment(this.modalDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.modalDateRange.endDate).format("YYYY-MM-DD"),
        keyword: this.selectedModalKeyword,
        interval: this.keywordInterval,
        client: this.client,
        language: this.selectedLanguage.key,
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        brand_name: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        category_name: this.finalSelectedCategory,
        product_name: this.selectedProduct?.length
          ? this.selectedProduct
              ?.filter((product) => product.key !== "All")
              .map((product) => product.key)
          : [],
        type_of_keyword: "token",
      };

      this.keywordWiseSentiments = {};
      this.modalLoader = true;
      this.isKeywordReview = true;
      this.$http
        .post(url, payload)
        .then((res) => {
          this.modalLoader = false;
          this.isKeywordData = false;
          this.keywordWiseSentiments = res.body.data;
          this.isKeywordData = false
        })
        .catch((err) => {
          this.modalLoader = false;
          this.isKeywordData = false;

          console.log(`Error in fetching keyword sentiments`, err);
        });
    },
    handlePlatformSelection(selected) {
      const otherOptions = this.platformList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSelection.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedPlatform = [...this.platformList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedPlatform = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedPlatform = [...this.platformList];
        } else {
          this.selectedPlatform = [...selectedWithoutAll];
        }
      }

      this.previousSelection = [...this.selectedPlatform];

      this.changeTableCategory();
    },

    changeTableCategory() {
      if (this.selectedPlatform) {
        this.selectedTableCategory = [];
        this.lossSelectedBrand = [];
        this.selectedProduct = [];
        this.lossSelectedPIN = [];
        const categoryMap = new Map();
        const subCategoryMap = new Map();

        this.categoryList = [];
        this.subCategoryList = [];
        this.selectedPlatform.forEach((platform) => {
          const platformKey = platform.key;
          const categories = this.allCategory[platformKey];

          if (categories?.length) {
            categories.forEach((cat) => {
              if (!categoryMap.has(cat.key)) {
                categoryMap.set(cat.key, cat);
                this.categoryList.push(cat);
              }

              if (cat.child?.length) {
                cat.child.forEach((sub) => {
                  if (!subCategoryMap.has(sub.key)) {
                    subCategoryMap.set(sub.key, sub);
                    this.subCategoryList.push(sub);
                  }
                });
              }
            });
          }
        });
        if (this.selectedPlatform.length) {
          this.categoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });
        }
        const stateMap = new Map();

        this.selectedPlatform.forEach((platform) => {
          const platformKey = platform.key;
          const states = this.allPincodeList[platformKey] || [];

          states.forEach((state) => {
            if (!stateMap.has(state.id)) {
              stateMap.set(state.id, {
                id: state.id,
                label: state.label,
                children: [],
              });
            }

            const stateEntry = stateMap.get(state.id);
            const cityMap = new Map(
              stateEntry.children.map((city) => [city.id, city])
            );

            state.children?.forEach((city) => {
              if (!cityMap.has(city.id)) {
                cityMap.set(city.id, {
                  id: city.id,
                  label: city.label,
                  children: [],
                });
              }

              const cityEntry = cityMap.get(city.id);
              const pinMap = new Map(
                cityEntry.children.map((pin) => [pin.id, pin])
              );

              city.children?.forEach((pin) => {
                if (!pinMap.has(pin.id)) {
                  pinMap.set(pin.id, {
                    id: pin.id,
                    label: pin.label,
                  });
                }
              });

              cityEntry.children = Array.from(pinMap.values());
            });

            stateEntry.children = Array.from(cityMap.values());
          });
        });

        this.lossPINList = Array.from(stateMap.values());

        // this.categoryList = this.allCategory[this.selectedPlatform?.key];
        // this.selectedTableCategory = [this.categoryList[0]];
        // this.subCategoryList = this.categoryList[0].child;
        // this.selectedTableSubCategory = [this.subCategoryList[0]];
        // this.lossPINList = this.allPincodeList[this.selectedPlatform?.key];
        this.handleChangeCategory();
      }
    },

    handleChangeCategory(selected) {
      if (!selected.length) {
        this.selectedTableSubCategory = [];
      }

      const otherOptions = this.categoryList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousCategorySelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedTableCategory = [...this.categoryList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedTableCategory = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedTableCategory = [...this.categoryList];
        } else {
          this.selectedTableCategory = [...selectedWithoutAll];
        }
      }

      this.previousCategorySelection = [...this.selectedTableCategory];
      this.getBrandData(false);
      this.handleChangeSubCategory();
      // this.$nextTick(() => {
      //   this.getBrandData(false);
      // });
    },
    handleChangeSubCategory(selected) {
      if (!selected.length) {
        this.selectedTableSubCategory = [];
      }
      const otherOptions = this.subCategoryList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSubCategorySelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedTableSubCategory = [...this.subCategoryList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedTableSubCategory = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedTableSubCategory = [...this.subCategoryList];
        } else {
          this.selectedTableSubCategory = [...selectedWithoutAll];
        }
      }

      this.previousSubCategorySelection = [...this.selectedTableSubCategory];

      // this.$nextTick(() => {
      this.getBrandData(false);
      // });
    },
    handleBrand(selected) {
      const otherOptions = this.lossBrandList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousBrandSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedBrand = [...this.lossBrandList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedBrand = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedBrand = [...this.lossBrandList];
        } else {
          this.lossSelectedBrand = [...selectedWithoutAll];
        }
      }

      this.previousBrandSelection = [...this.lossSelectedBrand];
      // this.$nextTick(() => {
      //   this.getProductIdData(false);
      // });
    },
    
    handleChangeL1(selected) {
      if (!selected.length) {
        this.selectedL2Data = [];
      }

      const otherOptions = this.viewL1Data.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousL1Selection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedL1Data = [...this.viewL1Data];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedL1Data = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedL1Data = [...this.viewL1Data];
        } else {
          this.selectedL1Data = [...selectedWithoutAll];
        }
      }

      this.previousL1Selection = [...this.selectedL1Data];
      this.viewL2Data = [];
      this.selectedL1Data.forEach((l1)=>{
        this.viewL2Data.push(l1.child || [])
      })
      this.viewL2Data = this.viewL2Data.flat()
      this.viewL2Data.unshift({
        key: "All",
        value: "All",
      });
      this.selectedL2Data = [...this.viewL2Data];
      this.previousL2Selection = [...this.selectedL2Data];
      // this.$nextTick(() => {
      //   this.getBrandData(false);
      // });
    },
    handleChangeL2(selected) {
      
      if (!selected.length) {
        this.selectedL2Data = [];
      }
      const otherOptions = this.viewL2Data.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousL2Selection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedL2Data = [...this.viewL2Data];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedL2Data = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedL2Data = [...this.viewL2Data];
        } else {
          this.selectedL2Data = [...selectedWithoutAll];
        }
      }
      this.previousL2Selection = [...this.selectedL2Data];

      // L2 Chategory change

    },
    handleApplyFilters() {
      if ($.fn.DataTable.isDataTable("#summaryTable")) {
        $("#summaryTable").DataTable().clear().destroy();
      }
      this.getSentimentData();
    },
    
    // getAllStatusByApi() {
    //   //   console.log('kpl')
    //   let self = this;
    //   self.loaderStatus = true;
    //   const url = "api/v2/sensespiderstatus";
    //   let payload = {
    //     // "client_id": "1e5b11d71bf84ee7ac584db27d458389",
    //     timestamp: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
    //     feature: "pincode",
    //   };
    //   self.$http
    //     .post(url, payload)
    //     .then((response) => {
    //       self.storeAllDataForStatus = response.body.data;
    //       if (
    //         Object.keys(self.storeAllDataForStatus).length &&
    //         self.selectedPlatform.key !== "") {
    //         self.$store.dispatch(
    //           "DemoStore/setUpdatedStatus",
    //           self.storeAllDataForStatus[self.selectedPlatform.key]
    //         );
    //       } else {
    //         self.$store.dispatch("DemoStore/setUpdatedStatus", "");
    //       }
    //       // self.loaderStatus = false;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       self.loaderStatus = false;
    //     });
    // },
    getFiltersData(isMounted) {
      let self = this;
      self.vocProductListLoader = true;
      const url = "/api/v2/product/filter_data";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      self.$http
        .post(url, payload)
        .then((response) => {
          this.platformList = response.data.data.platform;
          if (this.platformList.length) {
            this.platformList.unshift({ key: "All", value: "All" });
          }

          this.lossPriceRangeList = response.data.data.price_range;
          this.lossSelectedPriceRange = this.lossPriceRangeList;
          // this.lossPriceRangeList = this.lossPriceRangeList.filter(
          //   (price) => price.key != "all"
          // );
          this.selectedPlatform = [...this.platformList];
          this.previousSelection = [...this.selectedPlatform];
          if (Object.keys(response.data.data.batch).length) {
            this.lossBatchList = response.data.data.batch["price tracking"];
            this.lossSelectedBatch = this.lossBatchList[0];
            this.batchList = response.data.data.batch["price tracking"];
          }
          this.allCategory = response.data.data.category;
          this.categoryList = [];
          this.subCategoryList = [];
          const categoryMap = new Map();
          this.categoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });

          this.platformList.forEach((platform) => {
            const platformKey = platform.key;
            const categories = this.allCategory[platformKey];

            if (categories?.length) {
              categories.forEach((cat) => {
                if (!categoryMap.has(cat.key)) {
                  categoryMap.set(cat.key, cat);
                  this.categoryList.push(cat);
                }
              });
            }
          });
          this.selectedTableCategory = [...this.categoryList];
          this.previousSelection = [...this.selectedTableCategory];
          const stateMap = new Map();

          this.selectedPlatform.forEach((platform) => {
            const platformKey = platform.key;
            const states = response.data.data.pincode[platformKey] || [];

            states.forEach((state) => {
              if (!stateMap.has(state.id)) {
                stateMap.set(state.id, {
                  id: state.id,
                  label: state.label,
                  children: [],
                });
              }

              const stateEntry = stateMap.get(state.id);
              const cityMap = new Map(
                stateEntry.children.map((city) => [city.id, city])
              );

              state.children?.forEach((city) => {
                if (!cityMap.has(city.id)) {
                  cityMap.set(city.id, {
                    id: city.id,
                    label: city.label,
                    children: [],
                  });
                }

                const cityEntry = cityMap.get(city.id);
                const pinMap = new Map(
                  cityEntry.children.map((pin) => [pin.id, pin])
                );

                city.children?.forEach((pin) => {
                  if (!pinMap.has(pin.id)) {
                    pinMap.set(pin.id, {
                      id: pin.id,
                      label: pin.label,
                    });
                  }
                });

                cityEntry.children = Array.from(pinMap.values());
              });

              stateEntry.children = Array.from(cityMap.values());
            });
          });

          this.lossPINList = Array.from(stateMap.values());

          this.allPincodeList = response.data.data.pincode;

          this.getBrandData(isMounted).then(() => {
            this.getSentimentData();
          });

          //   this.lossSelectedPIN = this.lossPINList[0];
          //   this.setPlatformWiseDateTable(true);
          // this.getAllStatusByApi('forBuyBoxTable');
          self.vocProductListLoader = false;
        })
        .catch((err) => {
          console.log(err);
          self.vocProductListLoader = false;
        });
    },
    async getBrandData(isMounted) {
      const url = "/api/v2/brand/data";

      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category: this.finalSelectedCategory,
        //   ?
        //   : [],
        // product: [],
        pincode: this.lossSelectedPIN?.length ? this.lossSelectedPIN : [],
      };
      await this.$http
        .post(url, payload)
        .then((res) => {
          this.lossBrandList = res.data.data;
          if (this.lossBrandList.length) {
            this.lossBrandList.unshift({ key: "All", value: "All" });
          }
          this.lossSelectedBrand = [...this.lossBrandList];
          this.previousBrandSelection = [...this.lossSelectedBrand];
          return this.getL1andL2Data();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    async getL1andL2Data(){
  // $("#sentimentAnalysis").DataTable().destroy();
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }

      let finalProduct = [];
      if (this.selectedProduct.length == this.lossProductList.length) {
        finalProduct = ["all"];
      } else {
        finalProduct = this.selectedProduct
          ?.filter((product) => product.key !== "All")
          .map((product) => product.key);
      }

      this.tableLoader = true;
      const url = "api/v2/sentiment_l1_l2";

      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        platforms: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category: this.finalSelectedCategory,
        brand: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        language: this.selectedLanguage.key,
        // price_range: [],
        keyword: [],
      };
      await this.$http
        .post(url, payload)
        .then((res) => {
          this.tableLoader = false;
          // this.viewReviewSentimentData = res.data;
          //   this.tableData = res.data.data.data;
          this.storedL1L2Data = res.data.data;
          this.viewL1Data = res.data.data,
          this.viewL2Data = [],
           this.viewL1Data.unshift({
            key: "All",
            value: "All",
            child: [],
          });
          this.selectedL1Data = [...this.viewL1Data];
          this.previousL1Selection = [...this.selectedL1Data];
          this.viewL2Data = [];
          this.selectedL1Data.forEach((l1)=>{
            this.viewL2Data.push(l1.child || [])
          })
          this.viewL2Data = this.viewL2Data.flat()
          this.viewL2Data.unshift({
            key: "All",
            value: "All",
          });
          this.selectedL2Data = [...this.viewL2Data];
          this.previousL2Selection = [...this.selectedL2Data];
          this.sentimentLoader = false;
          // this.$nextTick(() => {
          //   this.processTable("#summaryTable");
          // });
        })
        .catch((err) => {
          console.error(err);
          this.tableLoader = false;
          this.sentimentLoader = false;
        });
    },
    
    getSentimentData() {
      // $("#sentimentAnalysis").DataTable().destroy();
      this.sentimentLoader = true;
      this.viewReviewSentimentData.headers = [];
      this.viewReviewSentimentData.data.table = [];
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }

      let finalProduct = [];
      if (this.selectedProduct.length == this.lossProductList.length) {
        finalProduct = ["all"];
      } else {
        finalProduct = this.selectedProduct
          ?.filter((product) => product.key !== "All")
          .map((product) => product.key);
      }

      this.tableLoader = true;
      const url = "/api/v2/new_sentiment_data_latest";

      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        platforms: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category: this.finalSelectedCategory,
        brand: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        language: this.selectedLanguage.key,
        // price_range: [],
        keyword: [],
        l1_filters: this.selectedL1Data?.length
          ? this.selectedL1Data
              ?.filter((p) => p.key !== "All")
              .map((l1) => l1.key)
          : [],
        l2_filters: this.selectedL2Data?.length
          ? this.selectedL2Data
              ?.filter((p) => p.key !== "All")
              .map((l2) => l2.key)
          : [],
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.tableLoader = false;
          this.viewReviewSentimentData = res.data;
          //   this.tableData = res.data.data.data;
          this.sentimentLoader = false;
          this.$nextTick(() => {
            this.processTable("#summaryTable");
          });
        })
        .catch((err) => {
          console.error(err);
          this.tableLoader = false;
          this.sentimentLoader = false;
        });
    },
  

    processTable(id) {
      $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        ordering: true,
        order: [],
        columnDefs: [
          {
            targets: 0,
            className: "min-width-column",
          },
        ],
        initComplete: function () {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });
      $(id + "_filter > label").append(
        `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
      );
    },
    exportSentimentTable() {
      const url = "/api/v2/indian_clients/sentiment/sentiment_excel";
      const payload = {
        table: this.viewReviewSentimentData,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          window.location = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.customtooltiptext {
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  left: 50%;
  margin-left: -60px;
  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

.borderBetweenTab {
  border-bottom: 1px solid rgba(213, 213, 213, 1) !important;
  margin-bottom: 15px !important;
}

.tab-label {
  cursor: pointer;
  padding-bottom: 5px;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 500;
}

.tab-label.active {
  color: rgba(6, 85, 89, 1);
  border-bottom: 1px solid rgba(6, 85, 89, 1);
  font-weight: 600 !important;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.borderBottom {
  border-bottom: 1px solid rgba(212, 212, 212, 1) !important;
  margin: 5px 0px !important;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}
.modal-control-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d4d4d4;

  & > ul {
    list-style: none;
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 0;
    padding: 0;

    & > li {
      padding-bottom: 16px;
      margin: 0;
      font-size: 16px;
      cursor: pointer;
    }

    & > li.selected-tab {
      border-bottom: 1px solid #065559;
      margin-bottom: -1px;
      color: #065559;
      font-weight: 500;
    }
  }
}

.horizontal-divider {
  border-bottom: 1px solid #d9d9d9;
}

.vertical-divider {
  border-right: 1px solid #d9d9d9;
}

.customInput {
  border-radius: 5px !important;
  height: 35px !important;
  border: 1px solid #e4e7ea;
  width: 220px;
  outline: none;
  font-family: "poppins";
  width: 100%;
}
</style>
<style>
#sentiments-filters .multiselect__strong {
  display: none !important;
}
</style>
